// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"f4ac002e","471":"2ebe5b9c","700":"546dc5ec"}[chunkId] + ".chunk.css";
};